export const smallModalWidth = 380;
export const wideModalWidth = 608;
